var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent"},[_c('h1',{staticClass:"parent-title"},[_vm._v("Parent")]),_c('p',{staticClass:"caption"},[_vm._v("small>子コンポーネントでイベント発生したら、親が引数を alert")]),_c('Child',{on:{"my-event":_vm.handleEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }